import { Link } from 'react-router'

import { linkBlue } from '@/refactor/colors'
import styled from '@/styles'

export const RouterLink = styled(Link)`
	:not(:visited) {
		color: ${linkBlue};
	}

	text-decoration: none;

	&:hover {
		text-decoration: underline;
	}
`
